import { useState } from 'react'
import type { Player } from '@/domain/player'
import { searchPlayers } from '@/domain/playerSearch'
import styles from './PlayerSelector.module.css'

interface ApiErrorLike {
  readonly message: string
}

interface Props {
  players: Player[]
  loading?: boolean
  error?: ApiErrorLike | null
  selectedId: string | null
  onSelect: (id: string) => void
}

export function PlayerSelector({ players, loading = false, error = null, selectedId, onSelect }: Props) {
  const [query, setQuery] = useState('')
  const filteredPlayers = searchPlayers(players, query)

  return (
    <section className={styles.container} aria-label="推し選手を選ぶ">
      <h2 className={styles.heading}>推し選手を選ぶ</h2>

      <div className={styles.searchField}>
        <label htmlFor="player-search-input" className={styles.searchLabel}>
          選手を検索（選手名またはよみがな）
        </label>
        <input
          id="player-search-input"
          type="search"
          className={styles.searchInput}
          placeholder="例: 岡本 / おかもと"
          value={query}
          onChange={(event) => { setQuery(event.target.value) }}
          autoComplete="off"
        />
      </div>

      {loading ? (
        <p role="status" className={styles.loading}>選手一覧を読み込み中です…</p>
      ) : error ? (
        <p role="alert" className={styles.error}>{error.message}</p>
      ) : filteredPlayers.length === 0 ? (
        <p className={styles.empty}>該当する選手が見つかりませんでした</p>
      ) : (
        <ul className={styles.list} role="list">
          {filteredPlayers.map((player) => (
            <li key={player.id}>
              <button
                className={[
                  styles.playerButton,
                  selectedId === player.id ? styles.selected : '',
                ].join(' ')}
                onClick={() => { onSelect(player.id) }}
                aria-pressed={selectedId === player.id}
              >
                {player.number && <span className={styles.number}>#{player.number}</span>}
                <span className={styles.name}>{player.name}</span>
                <span className={styles.team}>{player.team}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </section>
  )
}
